export const getEnvValue = (key: string): string => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return window?.Cypress ? window?.Cypress?.env(key) : import.meta.env[key];
};

const normalizeApiBaseUrl = (baseUrl: string): string => {
  if (typeof window === "undefined" || window.location.protocol !== "https:") {
    return baseUrl;
  }

  try {
    const url = new URL(baseUrl);
    if (url.protocol === "http:") {
      url.protocol = "https:";
      return url.toString();
    }
  } catch {
    return baseUrl;
  }

  return baseUrl;
};

export const apiURL = (path = "") => {
  const baseUrl = normalizeApiBaseUrl(getEnvValue("VITE_API_URL"));
  return new URL(path, baseUrl);
};

export const apiWebsocketURL = (path = "") => {
  const url = apiURL(path);
  if (url.protocol === "https:") {
    url.protocol = "wss:";
  } else if (url.protocol === "http:") {
    url.protocol = "ws:";
  }
  return url;
};

export const isProduction = !window?.Cypress && import.meta.env.MODE === "production";
export const isDevelopment = !window?.Cypress && import.meta.env.MODE === "development";
